<script>
  import { page, router } from '@inertiajs/svelte'
  import Button from './ui/button.svelte'

  // Set by the server from LEGACY_CMS_URL while the old CMS is still running, and nil once
  // this session dismissed the banner.
  const url = $derived($page.props.legacy_cms_url)
  let dismissed = $state(false)

  const dismiss = () => {
    dismissed = true
    router.delete('/legacy-cms-banner', { only: ['legacy_cms_url'], preserveState: true, preserveScroll: true })
  }
</script>

{#if url && !dismissed}
  <div class="bg-info text-info-content text-sm pl-4 pr-1 py-1 flex items-center gap-2" role="status">
    <p class="flex-1 text-center py-1">
      This is the new Zupp Admin. Something missing or not working?
      <a href={url} target="_blank" rel="noopener" class="link font-semibold whitespace-nowrap">Open the old admin</a>
    </p>
    <Button variant="ghost" size="xs" circle icon="close" aria-label="Dismiss" title="Hide until your next session" onclick={dismiss} />
  </div>
{/if}
